import { render, staticRenderFns } from "./PostForm.vue?vue&type=template&id=13b2d7a0&scoped=true&"
import script from "./PostForm.vue?vue&type=script&lang=js&"
export * from "./PostForm.vue?vue&type=script&lang=js&"
import style0 from "./PostForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PostForm.vue?vue&type=style&index=1&id=13b2d7a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b2d7a0",
  null
  
)

export default component.exports